import {SalesDto} from "../../../../../models/sales/sales-dto";
import {ModificationLineTransfer} from "../../../../../../../../_models/_booking/composition-override-linker-transfer";

export class Row {
  id: string;
  name: string;
  list: SalesDto[] = [];
  hasSpecialTag: boolean;
  medianPrice: number;
  sourceDetailPPU: number;
  //vat: number;
  soldUnits: number = 0;
  revenue: number;
  netRevenue: number = 0;
  /**
   * #534: the swap combination this row stands for, as the `├`/`└` lines the register already transmits
   * (#197/#198) — rendered under {@link name} while "Kombinationen einzeln" is on. Empty in combined mode
   * (and for an unmodified article in individual mode), which is exactly when the template renders no
   * sub-lines at all.
   */
  modificationLines: ModificationLineTransfer[] = [];

  constructor(id: string, name: string, list: SalesDto[], hasSpecialTag: boolean, medianPrice: number, sourceDetailPPU: number, orderCount: number, revenue: number, modificationLines: ModificationLineTransfer[] = []) {
    this.name = name;
    this.id = id;
    this.list = list;
    this.hasSpecialTag = hasSpecialTag;
    this.medianPrice = medianPrice;
    this.sourceDetailPPU = sourceDetailPPU;
    this.soldUnits = orderCount;
    this.revenue = revenue;
    this.modificationLines = modificationLines;
    //this.vat = vat

  }
}
